export default __webpack_public_path__ + "static/Logo-01-284c50b27e6dce059ee5aaf33ad5c2da.png";